import { FleetNavigationModule } from "@app/main/modules/fleet/fleet.navigation";
import { StateService } from "@uirouter/angularjs";
import * as angular from "angular";
import "./hideInProduction.scss";

export class HideInProduction implements angular.IDirective {

    restrict = "A";
    terminal = true;
    priority = 1000;

    link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;

    constructor(
        private readonly $compile: angular.ICompileService,
        private readonly $state: StateService,
        private readonly $location: angular.ILocationService
    ) {
        HideInProduction.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes) => {

            var url = $location.absUrl();

            var developmentDomains: string[] = [
                "localhost:",
                "dev.",
                "uat."
            ];

            const localhostOnly = $attrs["localhostOnly"] as boolean;
            const redirect = $attrs["redirect"] as string;

            const isUsingLocahost: boolean = url.indexOf("localhost") === -1 || apiUrl.indexOf("localhost") === -1;
            const isUsingDevelopment: boolean = developmentDomains.some(developmentDomain => url.indexOf(developmentDomain) > 1);

            const removeElement = localhostOnly ? isUsingLocahost : !isUsingDevelopment;

            if (removeElement) {
                if (redirect && redirect.toLowerCase() === "true") {
                    this.$state.go(FleetNavigationModule.Default);
                }
                else {
                    $element.remove();
                }
            }
            else {
                $element.removeAttr("hide-in-production");
                $element.removeAttr("localhost-only");
                $compile($element)($scope);
                $element.addClass("hide-in-production");
            }
        }
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($compile: angular.ICompileService, $state: StateService, $location: angular.ILocationService) => new HideInProduction($compile, $state, $location);

        directive.$inject = ["$compile", "$state", "$location"];

        return directive;
    }
}
